module.exports = "<button (click)=\"testInfo()\">Test info modal</button>\n<button (click)=\"testWarning()\">testWarning modal</button>\n<button (click)=\"testError()\">testError modal</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/test-modal/test-modal.component.html
// module id = ./src/app/test-modal/test-modal.component.html
// module chunks = main